export function SkipLink() {
  return (
    <a href="#main" className="skip-link">
      본문 바로가기
    </a>
  );
}
